import { CourseMaterialEnum } from '@/interfaces/training.interface';
import { PATH_NAME } from 'configs/pathName';
import { UrlObject } from 'url';

export const generatePathname = (props: UrlObject | string) => {
  if (typeof props === 'string') return props;

  const { pathname: _, query } = props as {
    pathname: string;
    query: { [key: string]: string };
  };

  let pathname = _;

  for (let key in query) {
    pathname = pathname.replace(`[${key}]`, query[key]);
  }

  return pathname;
};

export const generateTrialLearningLink = ({
  courseId,
  materialId,
  materialType,
}: {
  courseId: string;
  materialType: CourseMaterialEnum;
  materialId: string;
}): UrlObject => {
  switch (materialType) {
    case CourseMaterialEnum.Lesson:
      return {
        pathname: PATH_NAME.LESSON,
        query: {
          cid: courseId,
          lid: materialId,
          isTakingTrial: true,
        },
      };

    case CourseMaterialEnum.Quiz:
      return {
        pathname: PATH_NAME.QUIZ,
        query: {
          cid: courseId,
          qid: materialId,
          isTakingTrial: true,
        },
      };

    default:
      return {
        pathname: PATH_NAME.PLAY_H5P,
        query: {
          cid: courseId,
          h5pid: materialId,
          isTakingTrial: true,
        },
      };
  }
};

export const generateCourseMaterialUrl = ({
  materialId,
  materialType,
  courseId,
}: {
  materialType: CourseMaterialEnum;
  materialId: string;
  courseId: string;
}): UrlObject => {
  const hashPathname = {
    [CourseMaterialEnum.Quiz]: PATH_NAME.QUIZ,
    [CourseMaterialEnum.Lesson]: PATH_NAME.LESSON,
    [CourseMaterialEnum.H5P]: PATH_NAME.PLAY_H5P,
  };

  const hashIdParam = {
    [CourseMaterialEnum.Quiz]: 'qid',
    [CourseMaterialEnum.Lesson]: 'lid',
    [CourseMaterialEnum.H5P]: 'h5pid',
  };

  const query = {
    cid: courseId,
    [hashIdParam[materialType]]: materialId,
  };

  return {
    pathname: hashPathname[materialType],
    query,
  };
};
